<template>
    <html>

    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta http-equiv="Content-Style-Type" content="text/css" />
        <title>
        </title>
    </head>

    <body>
        <PropsTable ref="propsTable1" @onLink="open"></PropsTable>
        <Collapse class="colaps" v-model="relatedValue" size="large" simple :style="{display:show?'block':'none',borderBottom:'0px'}">
            <Panel name="1" size="large" class="cpllapse-panel-title">
                附件
                <div slot="content">
                    <Attachment ref="relatedFiles" :style="{display:'block'}"></Attachment>
                    <!-- <RelatedFile ref="relatedHistoryFile" @u-remove-row="removeHistoryrow"></RelatedFile> -->
                </div>
            </Panel>
        </Collapse>
        <!-- :icon="isPlay?'md-pause':'md-play'" -->
        <div style="text-align: left;padding-top:20px;padding-left: 15px;">
            <!-- <ButtonGroup>
                <Button type="default" size="large" :class="!isPlay && !isPause?'btnplay btnplay2':'btnplay btnplay1'" :icon="isPlay?'md-pause':'md-play'" @click="textPlay">
                </Button>
                <Button size="large" class="btnstop" icon="md-square" @click="textStop"></Button>
                <div style="background-color:#F5F6FA;display: flex;align-items: center;line-height: 40px;padding-left: 10px;border-radius:0px 20px 20px 0px;width:80px;">语音播报</div>
            </ButtonGroup> -->
            <!-- <audio controls :src="playsrc"></audio> -->
            <!-- audio -->
            <ButtonGroup style="padding-left: 10px;">
                <Button type="default" size="large" :class="!isPlay && !isPause?'btnplay btnplay2':'btnplay btnplay1'" :icon="isPlay?'md-pause':'md-play'" @click="audioPlay">
                </Button>
                <Button size="large" class="btnstop" icon="md-square" @click="audioStop"></Button>
                <div style="background-color:#F5F6FA;display: flex;align-items: center;line-height: 40px;padding-left: 10px;border-radius:0px 20px 20px 0px;width:100px;">云语音播报</div>
            </ButtonGroup>
             
            <!-- 打印 -->
            <div style="display: inline-block;float: right;padding-right: 18px;"> <Button type="dashed" icon="md-print" style="box-shadow: none;" @click="goPrint">打印</Button></div>
            <!-- 邮件 -->
            <div style="display: inline-block;float: right;padding-right: 18px;"> <Button type="dashed" icon="md-mail" style="box-shadow: none;" @click="sendMail">邮件</Button></div>
        </div>
        <div ref="docFileHtml" id="docHtml" :name="docname" v-html="value1" class="defaultFont" style="margin: 10px;" @click="open">
        </div>
    </body>

    </html>
</template>
<script>
import PrintView from './printer.vue'
import PropsTable from './docpropstable.vue'
import PropsTableData from '../../../assets/json/elementTableData.json'
import RelatedFile from '../../../components/smart_cloud/workbook_related_table.vue'
import { base } from '../util.js'
import store from '../../../store/'
import { mapGetters } from 'vuex'
import { uuid } from 'vue-uuid'
import { getAeskey } from '../../../api/lib/sign.js'
import CryptoJS from 'crypto-js'
import ConstJson from "../../../api/common/constjson.js"
import eventBus from "../../../components/common/event_bus.js"
let constJ = new ConstJson()
export default {
    name: 'ShowDocument',
    props: {
        docfileid: String,
        order: Number,
        trow: Object,
    },
    inject: ["getSliders"],
    data() {
        return {
            value1: "",
            show: false,
            relatedValue: [],
            docname: this.$Tools.strGuid(),
            isPlay: false,
            isPause: false,
            playsrc: "",
            uurow:this.trow,
            loadDocRow:null,
        }
    },
    methods: {
        checkUserLogin() {
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
        sendMail(){
            if (this.checkUserLogin()) {
                //let row=this.$parent.$parent.$parent.gorow
                //console.log(this.row)
                // let strid=this.$parent.$parent.$parent.text
                if(this.uurow){
                    eventBus.$emit("send-mail-with-file",this.uurow) 
                }else{
                    eventBus.$emit("send-mail-with-file",this.loadDocRow) 
                }
                
            } else {
                console.log('sendMail user-login')
                eventBus.$emit("user-login", "true", '2') //临时登录
            }

        },
        goPrint() {
            //console.log("goPrint==>")
            if (this.checkUserLogin()) {
                let c = this.getPrintContent()
                if(this.uurow){
                    eventBus.$emit("printer", c, this.uurow)
                }else{
                    eventBus.$emit("printer", c, this.loadDocRow)
                }
                
            } else {
                console.log('goPrint user-login')
                eventBus.$emit("user-login", "true", '2') //临时登录
            }

            //console.log("goPrint.getPrintTxt")
            // console.log(c)
            //this.$refs.myprinter.setBodyHtml2(c)
        },
        getPrintContent() {
            return this.$refs.docFileHtml.innerHTML
        },
        getAudioUrl(row) {
            try {
                console.log(row)
                //处理strdocid不存在的情况
                let strid=''
                if(row.masterdocidstr && row.masterdocidstr!==''){
                    strid=row.masterdocidstr
                }else if(!row.strdocid && row.fileid){
                    row.strdocid=row.fileid
                    strid= row.strdocid
                }else {
                    strid= row.strdocid
                }

                constJ.reqGetTTSStream(strid).then(res => {
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            //this.$Message.success('获取tts成功');
                            this.playsrc=res.item.signedurl
                            eventBus.$emit("audiotts-play", this.docname, this.playsrc, row)
                            console.log("获取tts文件流成功");
                        } else {
                            this.$Message.warning(res.rltdesc);
                            this.isPlay = false
                        }
                    } else {
                        this.$Message.warning(res.rtndesc);
                        this.isPlay = false
                    }
                })
            } catch (e) {
                console.log("获取tts文件流异常");
                console.log(e);
            }
        },
        audioPlay() {
            if (this.checkUserLogin()) {
                console.log(this.uurow)
                if (this.isPlay) {
                    if(this.uurow){
                        eventBus.$emit("audiotts-play", this.docname, this.playsrc, this.uurow)
                    }else{
                        eventBus.$emit("audiotts-play", this.docname, this.playsrc, this.loadDocRow)
                    }
                    this.audioPause()
                }else{
                    if(this.uurow){
                        this.getAudioUrl(this.uurow)
                    }else{
                        this.getAudioUrl(this.loadDocRow)
                    }
                    this.isPlay = true
                }
                
            } else {
                console.log('textPlay user-login')
                eventBus.$emit("user-login", "true", '2') //临时登录
            }
        },
        audioPause() {
            eventBus.$emit("audiotts-pause", this.docname)
            this.isPlay = false
            this.isPause = true
        },
        audioStop() {
            eventBus.$emit("audiotts-stop", this.docname)
            this.isPlay = false
            this.isPause = false
        },
        textPlay() {
            if (this.checkUserLogin()) {
                let txt = document.getElementsByName(this.docname)[0].innerText
                if (this.isPlay) {
                    this.textPause()
                } else {
                    eventBus.$emit("tts-play", txt, this.docname, this.uurow)
                    this.isPlay = true
                }
            } else {
                console.log('textPlay user-login')
                eventBus.$emit("user-login", "true", '2') //临时登录
            }
        },
        textStop() {
            eventBus.$emit("tts-stop", this.docname)
            this.isPlay = false
            this.isPause = false
        },
        textPause() {
            eventBus.$emit("tts-pause", this.docname)
            this.isPlay = false
            this.isPause = true
        },
        //权限控制
        checkPermission(code) {
            //"000014" // 普通下载
            let rsp = false
            let checkcode = code
            let permission = this.sta.permission
            if (permission && permission.length > 0) {
                let index = permission.findIndex(p => p.f === checkcode)
                console.log('checkcode.index:' + index)
                if (index >= 0) {
                    rsp = true
                }
            }
            return rsp
        },
        //scene: "policy"=政策,scene: "answer" =解答
        handleLoadDoc(row) {
            // this.$Loading.start();
            //var fileid = row.docid
            var fileid = row.strdocid
            //console.log(row)
            constJ.reqDisplayFile2(row).then(res => {
                //let dataObj=JSON.parse(res)
                console.log("handleLoadDoc......")
                console.log(res)
                //console.log(res.rtncode)
                // var encrypted = CryptoJS.AES.encrypt("Message", "Secret Passphrase", {
                //   mode: CryptoJS.mode.CFB,
                //   padding: CryptoJS.pad.AnsiX923
                // });
                // console.log(encrypted.key)
                // console.log(store.state.user.token)
                //console.log(this.getSliders())

                //console.log(a)


                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        console.log(this.trow)
                        this.loadDocRow=res.item
                        if (this.trow) {
                            //判断场景值
                            this.trow.jd = res.item.scene === 'answer' ? true : false
                            this.trow.wsw = res.item.scene === 'paperword' ? true : false
                            //税务案例
                            this.trow.case = res.item.scene === 'taxnews' ? true : false
                        }
                        var elementRows = []
                        if (res.item !== null && res.item !== undefined) {
                            // elementRows = [
                            //   { elementtext: res.item.headers.fcodehtml, elementname: '文号' },
                            //   { elementtext: res.item.pdate, elementname: '成文时间' },
                            //   { elementtext: res.item.publisher, elementname: '制定(发文)单位' },
                            //   { elementtext: res.item.potence, elementname: '文件效力' }
                            // ]
                            for (let i = 0; i < res.item.headers.length; i++) {
                                let element = {
                                    elementtext: res.item.headers[i].v,
                                    elementname: res.item.headers[i].t
                                }
                                elementRows.push(element)
                            }

                        }
                        //根据返回的数据刷新sliders列表
                        this.$emit('onDocFinished', res.item, '')
                        //叠加计算已打开的文件次数
                        if (res.item.scene !== 'paperword') {
                            store.state.user.opendocnum += 1
                        }

                        console.log("isShowLogin:" + res.item.hidden)
                        // console.log("elementRows:" + elementRows)
                        this.showDoc(res.item.body, elementRows, res.item.hidden)

                    } else {
                        console.log("handleLoadDoc:" + res.rltdesc)
                        if (res.rltcode === -300) {
                            //-300的文件需要下载
                            if (!this.checkUserLogin()) {
                                console.log('downloadfile->checkUserLogin')
                                eventBus.$emit("user-login", "true", "0") //临时登录
                                this.$Message.error(res.rltdesc)
                                this.removePage()
                                return
                            }

                            //检查一普通下载权限
                            let code = "000014"
                            let accountstatus = this.sta.accountstatus
                            if (!this.checkPermission(code)) {
                                if (accountstatus === 0) {
                                    this.$Message.warning('要体验普通下载功能，请您先注册')
                                    this.$Message.error(res.rltdesc)
                                    this.removePage()
                                    return
                                } else if (accountstatus === 100) {
                                    eventBus.$emit('user-nopermission-board', '要获得普通下载权限,请前去在线商城购买账号等级')
                                    this.$Message.error(res.rltdesc)
                                    this.removePage()
                                    return
                                }
                            }

                            constJ.reqDownLoadOneFile(fileid, this.removePage, this.showMessage)
                            this.$Message.success("文件下载中,请稍后...")


                        }
                        //-1030超出文件阅读上限次数提示
                        if (res.rltcode === -1030) {
                            const txt = '要增加文件阅读上限次数,请前去“在线商城”升级至专业版服务<br />服务热线：028-66612366'
                            eventBus.$emit('user-nopermission-board', txt)
                            this.$Message.error(res.rltdesc)
                            this.removePage()
                            return
                        } else {
                            this.$Message.error(res.rltdesc)
                            this.removePage()
                        }
                    }
                } else {
                    this.$Message.error(res.rtndesc)
                    this.removePage()
                    console.log("handleLoadDoc:" + res.rtndesc)
                }

                // this.$Loading.finish();
            }).catch(err => {
                // this.$Loading.error()
                this.$Message.error(err.message)
                this.removePage()
                console.log(err)
            })

        },

        removePage() {
            this.$emit('remove')
        },
        showMessage(msg) {
            if (msg === undefined || msg === "") {
                this.$Message.error("文件下载出错...")
            } else {
                this.$Message.error(msg)
            }

        },
        handleLoadWorkbookoptions(fileid) {
            console.log(fileid)
            constJ.getWorkBookItemsById(fileid).then(res => {
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        console.log(res)
                        var elementRows
                        elementRows = [
                            { elementtext: res.title, elementname: '标题' },
                            { elementtext: res.industrydesc, elementname: '行业' },
                            { elementtext: res.taxdesc, elementname: '税种' },
                            { elementtext: res.customlabel, elementname: '自定义标签' },
                            { elementtext: res.keyword, elementname: '关键词' }
                        ]
                        var files = []
                        var items = res.appendix;

                        for (let i = 0; i < items.length; i++) {
                            var file = {
                                fileid: items[i].docid,
                                filename: items[i].h1,
                                index: 0,
                                key: uuid.v1(),
                            }
                            files.push(file)
                        }
                        // console.log(files)
                        this.showDoc(res.contenttext, elementRows)
                        this.$refs.relatedFiles.bindData(files, 3)
                    } else {
                        console.log(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        showDoc(data, element, isShowLogin) {
            //console.log(PropsTableData)
            //this.$refs.propsTable1.bindData(PropsTableData.tabrows)
            // 63275
            this.$refs.propsTable1.bindData(element, this.trow)
            let tempdata = base.b64_to_utf8(data)
            //跳转标签
            //var tt="<tt lang='10000' style='text-decoration:underline;color:red;'>版本汇总</tt>" 
            //var aa = "<mm id='63275' style='text-decoration:underline;color:blue;'>人所得税政策有关问题的通知<tail>2018年施行</tail></mm>"
            //var cc ="<cc id='10000'>版本汇总01</cc>"
            //var dd ="<hit id='10000'>版本汇总01</hit>"
            // var img="<img src='/static/images/logo.png' width='100%'>"
            //this.value1 =tt+ tempdata+cc
            //console.log(tempdata)

            //特殊处理img
            // this.$nextTick(() => {
            //   let imgs = document.getElementById('docHtml').getElementsByTagName('img')
            //   console.log(imgs)
            //   if (imgs !== undefined && imgs.length > 0) {
            //     for (let i = 0; i < imgs.length; i++) {
            //       //console.log(imgs[i].outerHTML)
            //       let orisrc = imgs[i].src
            //       if (orisrc.indexOf('doc_images') > 0) {
            //         orisrc = orisrc.substring(orisrc.indexOf('doc_images') - 1)
            //         imgs[i].src = this.$baseConfig.host + orisrc
            //       }

            //       //console.log()
            //     }
            //   } else {
            //     console.log('无img')
            //   }

            // })


            //var cc = "<item class='ls ls_w' id='25228' seq='1'>干条文解释与执行的通知 </item>"
            //var img = "<img src='/static/images/img/downloadico.png' />"
            var linkbtn = "<div class='mask'><login class='linkbtn'>登录/注册</login></div>"
            this.value1 = tempdata.replace(/\r?\n/g, '<br />')
            if (isShowLogin) {
                this.value1 += linkbtn
            }
            //this.value1 = tempdata.replace(/\r?\n/g, '<br />') //+ img //+ cc //+dd //+ aa //+ aa+cc
            //console.log(this.$baseConfig)
            //console.log(document.getElementById('docHtml').getElementsByTagName('img'))
            this.$emit('loadComplete', this.trow)
        },
        searchSCParent(el) {
            let rlt = false
            var i = 0
            while (i < 6) {
                el = el.parentElement
                //向上查找的第一层包含链接，则需要先取消链接
                if (i === 0 && el.nodeName === "ITEM") {
                    //this.$Message.error("选区第一层父元素中包含链接,请先取消链接")
                    break;
                }
                console.log("第" + i + "次向上查找,name:" + el.nodeName)
                if (el.nodeName === "SC") {
                    rlt = true
                    break;
                }
                i++;
            }
            return rlt
        },
        checkChild(el) {
            let rlt = false
            if (el.hasChildNodes()) {
                var tagitem = el.getElementsByTagName('ITEM')
                if (tagitem.length > 0) {
                    rlt = true
                }
                // console.log(el.childNodes)
                // for (let i = 0; i < el.childNodes.length; i++) {
                //   if (el.childNodes[i].nodeName === 'ITEM') {
                //     rlt = true
                //     break;
                //   }
                // }
            }
            return rlt;
        },
        checkUserLogin() {
            // console.log(store.state.user.userId)
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
        open(value) {
            //console.log(value.srcElement.id)
            // var docmentId = value.srcElement.id
            // var ScrollToId = value.srcElement.lang
            //console.log(value.srcElement.tagName)
            //console.log(value)
            let selector = value.srcElement

            //var text = value.srcElement.innerHTML.replace(/<\/?[^>]*>/g, '')//去掉内容种包含的html标记
            console.log("parent.name:" + value.srcElement.parentElement.localName)
            //console.log("node.attributes.src:"+value.srcElement.attributes["src"].nodeValue)
            console.log(value)
            //var text = value.srcElement.innerText //note at 2019.09.16
            var text = value.srcElement.innerHTML

            // console.log(value.srcElement.innerHTML)
            if (selector.tagName === "ITEM") {
                if (selector.id) {
                    this.$emit('onOpen', selector.id, '', text)
                    //eventBus.$emit("on-link-open",selector.id)
                } else {
                    return
                }
            } else if (selector.tagName === "TT") {
                //console.log(selector.lang)
                this.scrollIntoViewResult(selector.lang)
            } else if (selector.tagName === "LOGIN") {
                if (!this.checkUserLogin()) {
                    eventBus.$emit("user-login", "true", "0") //临时登录
                }

            } else {
                let count = 0;
                while (selector.parentElement !== undefined && count < 2) {
                    var parent = selector.parentElement
                    if (parent.tagName === "ITEM" && parent.id > 0) {
                        this.$emit('onOpen', parent.id, '', text)
                        break;
                    } else {
                        count++;
                    }
                }
            }

            ////////////////////////////////////////////////////////////////////////////////////////////
            // var container=document.getElementById('docHtml').getElementsByTagName("sc")[0].innerHTML
            // console.log(container)

            // var range = document.getSelection()
            // console.log(range)
            // if (range.type === "Range") {
            //   console.log("选取文本：")
            //   console.log(range.toString())
            //   console.log("选取文本的html")
            //   var html = range.getRangeAt(0)
            //   var currentElement = html.commonAncestorContainer
            //   console.log("currentElement:")
            //   console.log(currentElement.nodeName)
            //   console.log(currentElement)
            //   if (currentElement.nodeName === "SC") {
            //     //检查元素下面是否包含带链接的tag
            //     if (this.checkChild(currentElement)) {
            //       this.$Message.error("选区中包含链接,请先取消链接")
            //       return
            //     } else {
            //       this.$Message.success("选择有效")
            //     }
            //   } else {
            //     //向上查找
            //     if (this.searchSCParent(currentElement)) {
            //       //检查元素下面是否包含带链接的tag
            //       if (this.checkChild(currentElement)) {
            //         this.$Message.error("选区子元素中包含链接,请先取消链接")
            //         return
            //       } else {
            //         this.$Message.success("选择有效")
            //       }

            //     } else {
            //       this.$Message.error("选择无效")
            //       console.log("当前选区内html:")
            //       console.log(currentElement)
            //       console.log("当前选区父级内html:")
            //       console.log(currentElement.parentElement)
            //     }
            //     //console.log(html.commonAncestorContainer.parentElement.nodeName)


            //   }


            //   html = html.cloneContents()
            // console.log(html)

            // } else {
            //   console.log("未选中文本")
            // }

            ////////////////////////////////////////////////////////////////////////////////////////


            // if (docmentId !== undefined && docmentId > 1) {
            //   this.$emit('onOpen', docmentId, '', 'aa')
            // } else if (ScrollToId !== undefined && ScrollToId > 1) {
            //   this.scrollIntoViewResult(ScrollToId)
            // } else {
            //   // console.log("return")
            //   return
            // }

            //onsole.log(value.srcElement.id)
            //console.log("ok1111")
            // docmentId=this.this.docfileid
            // console.log("docid:"+docmentId)

        },
        cclick(value) {
            console.log(value)
            let selector = value.srcElement
            if (selector.tagName === "ITEM") {
                if (selector.id !== undefined && selector.id > 1) {
                    this.$emit('onOpen', selector.id, '', 'aa')
                } else {
                    return
                }
            }
        },
        scrollIntoViewResult(id) {
            var element = document.getElementById(id);
            element.scrollIntoView();
        },
        loadDoc(fileid) {
            var fid = ""
            if (fileid !== undefined && fileid !== "") {
                fid = fileid
            } else {
                fid = this.docfileid
            }


            console.log("showdocument orderid:" + this.order)
            console.log("strdocid:" + fid)
            console.log(this.trow)
            var row = {
                strdocid: fid,
                docid: 0,
                h1hit: this.trow === undefined ? [] : this.trow.h1hit,
                chit: this.trow === undefined ? [] : this.trow.chit,
                cutwords: this.trow === undefined ? [] : this.trow.cutwords,
                chitseq: this.trow === undefined || this.trow.chitseq === null ? [] : this.trow.chitseq,
            }
            if (this.order === 1) {
                //this.handleLoadDoc(this.docfileid)
                this.handleLoadDoc(row)
            } else if (this.order === 2) {
                this.show = true
                this.handleLoadWorkbookoptions(fid)
            } else {
                this.handleLoadDoc(row)
            }
        },
    },
    components: {
        'PropsTable': PropsTable,
        'Attachment': RelatedFile,
        'Printer': PrintView,
    },
    computed: {
        ...mapGetters(['getUserId', 'sta'])
    },
    updated() {
        // var img = document.createElement('img')
        // console.log(document.getElementById('docHtml').getElementsByClassName('ls_w')[0])
        // document.getElementById('docHtml').getElementsByClassName('ls_w')[0].backgroundImage="../../../../static/images/img/download.png"
    },
    mounted() {
        // this.$nextTick(() => {
        // })
        console.log('showdocment.mounted====>')
        this.loadDoc()

    },
    watch: {
        // getUserId: function() {
        //   if(this.checkUserLogin()){
        //     this.loadDoc()
        //   }
        // }
    }

}
</script>
<style lang="less">
// @bg: #999;
* {
    word-wrap: break-word;
    word-break: break-all;
}

hh1,
hh2,
hh3,
hh41,
hh42,
hh5,
hh6,
hh7,
hh81,
hh82,
sc,
p {
    margin: 0pt;
    font-weight: normal;
    line-height: 200%;
}

item,
sr,
pah,
cc {
    line-height: 200%;
}

//判例副标题
hhh1 {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px dashed gray;
    display: block;
    text-align: center;
    line-height: 150%;
    font-size: 14pt;
    font-weight: normal;
}

hhh2 {
    display: block;
    text-align: right;
}

hhh3 {
    hh6 {
        display: block;
        text-align: left;
    }
}

//文件名
hh1 {
    display: block;
    text-align: center;
    line-height: 150%;
    font-size: 18pt;
    font-weight: normal;
}

//文号
hh2 {
    text-align: center;
    line-height: 300%;
    font-size: 10pt;
    font-weight: normal;
    display: block;
}

//废止依据
hh3 {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

hh4 {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

hh41 {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

hh42 {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

//发文单位
hh5 {
    text-align: right;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

//发文时间
hh6 {
    text-align: right;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

//附件
hh7 {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

// hh9 {
//   text-align: justify;
//   line-height: 300%;
//   font-size: 12pt;
//   font-weight: normal;
//   display: block;
// }

//相关链接
hh81 {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

//版本汇总
hh82 {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

sc {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
}

basis {
    font-size: 12pt;
    font-weight: normal;
    line-height: 200%;
    color: #c00000;
}

potencedesc {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    display: block;
    color: #c00000;
}

tt {
    text-align: justify;
    line-height: 200%;
    font-size: 12pt;
    font-weight: normal;
    .defaultFont
}

sr {
    color: #c00000
}

// item sr {
//   color: #c00000
// }

// cc sr {
//   color: #c00000
// }


.ls {

    //text-decoration: underline;
    color: blue;
    cursor: Pointer;
}

.ls_w:after {
    font-family: "iconfont" !important;
    font-size: 12pt;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\e62e";
    //background-image: url(../../../../static/images/img/download.png);
}

// .icon-download19:after{
//   content: "\e62e";
// }


.ls_e {
    color: blue;
    cursor: Pointer;

}

.ls_z {
    color: blue;
    cursor: Pointer;

}

.ls_o {
    color: blue;
    cursor: Pointer;

}

.defaultFont {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    position: relative;
    min-height: 658px; //文件内容区域body默认高度
}

#hh9 {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 50px 50px 50px;
    grid-auto-flow: column;


}

hh9 {
    font-size: 16px;
    text-align: left;
    //border: 1px solid #e5e4e9;
}

hit {
    background-color: yellow;
}


// @font-face {
//   font-family: 'iconfont';  /* project id 1591462 */
//   src: url('//at.alicdn.com/t/font_1591462_cljwfexo0l8.eot');
//   src: url('//at.alicdn.com/t/font_1591462_cljwfexo0l8.eot?#iefix') format('embedded-opentype'),
//   url('//at.alicdn.com/t/font_1591462_cljwfexo0l8.woff2') format('woff2'),
//   url('//at.alicdn.com/t/font_1591462_cljwfexo0l8.woff') format('woff'),
//   url('//at.alicdn.com/t/font_1591462_cljwfexo0l8.ttf') format('truetype'),
//   url('//at.alicdn.com/t/font_1591462_cljwfexo0l8.svg#iconfont') format('svg');
// }

// hh9:nth-child(-n+3){
//   color:red;
//   float:left;
//   width: 50%;
//   //display: table-row-group;
//   padding-left: 10px;
//   background-color: lightgreen;
//   //clear:both;

// }

// hh9:nth-last-child(-n+3){
//   color:blue;
//   float:left;
//   //display: table-row-group;
//   padding-left: 10px;
//   width: 50%;
//   background-color: lightgray;
//   //clear:both;
// }


//申请试用button
.linkbtn {
    background-color: #44c767;
    border-radius: 28px;
    border: 1px solid #fff;
    display: inline-block;
    cursor: pointer;
    color: #ffffff;
    font-family: Arial;
    font-size: 17px;
    padding: 16px 31px;
    text-decoration: none;
    text-shadow: 0px 1px 0px #16a600;
    margin: 30px 0 10px 45%;
}

.linkbtn:hover {
    background-color: #68de28;
}

.linkbtn:active {
    position: relative;
    top: 1px;
}


//遮罩
.mask {
    position: absolute;
    top: 80%;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 998;
    //background: #076585;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to top, #f8f8f9, rgba(255, 255, 255, 0.8));
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to top, #f8f8f9, rgba(255, 255, 255, 0.8));
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */


}

img {
    margin-bottom: -2px;
}

.btnplay {
    box-shadow: none;
    border: none;
    border-radius: 0px;
}


body>div:nth-child(1)>div {
    border-bottom: 0px;
}


.btnstop {
    box-shadow: none !important;
    border: none !important;
    background-color: #F5F6FA !important;
}

.btnstop.ivu-btn>.ivu-icon {
    color: #2E333C;
}

.btnstop.ivu-btn>.ivu-icon:hover {
    //图标颜色过度
    color: #2878FF;
    transition: color .2s linear, background-color .2s linear, border .2s linear, box-shadow .2s linear;
}

.btnplay {
    border-radius: 0px 0px 0px 0px !important;
    box-shadow: none !important;
    border: none !important;
    background-color: #F5F6FA !important;
}

//播放按钮样式
.btnplay1.ivu-btn>.ivu-icon {
    color: #2878FF;
    font-size: 20px; //图标大小
}

.btnplay2.ivu-btn>.ivu-icon {
    color: #2E333C;
    font-size: 20px; //图标大小
}

.btnplay2.ivu-btn>.ivu-icon:hover {
    //图标颜色过度
    transition: color .2s linear, background-color .2s linear, border .2s linear, box-shadow .2s linear;
    color: #2878FF;
}
</style>